import { useTranslations } from "next-intl";
import { useSizeReferenceDisplay } from "@hooks/use-current-user";
import ProductImage from "@components/core/ProductImage";
import SizeReferenceMention from "@components/core/SizeReferenceMention";
import translateVariantSize from "@utils/translateVariantSize";
import sizeTypes from "@utils/constants/sizeTypes";

function ReviewClosetItem({ closetItem }) {
  const t = useTranslations("common");

  const sizeReference = useSizeReferenceDisplay();

  if (!closetItem.id) return null;

  return (
    <div className="review-closet-item">
      <div className="img-container">
        <ProductImage
          src={closetItem.product.main_picture_url || ""}
          alt={closetItem.product.name}
          sizes="128px"
        />
      </div>
      <div className="content-container">
        <h6 className="mb-0 text-1-line">{closetItem.product.name}</h6>
        <p className="mb-0 font-size-sm text-gray text-1-line">{closetItem.product.brand.name}</p>
        <p className="mb-0 font-size-sm text-gray">
          {t("variant_size", {
            size: translateVariantSize(
              closetItem.variant.size?.type,
              closetItem.variant.size?.value,
              t,
              sizeReference,
            ),
          })}
          {closetItem.variant.size?.type === sizeTypes.size_fr && <SizeReferenceMention />}
        </p>
      </div>
    </div>
  );
}

export default ReviewClosetItem;
